
import Vue from 'vue'
import DownloadButton from './DownloadButton.vue'
import ModalComponent from '../ModalComponent.vue'
import store from '../../store'
import axios from 'axios'
import { ShareLinkBuilderService } from '../share/ShareLinkBuilder'
import { DEFAULT_BASE_URL } from '../share/constants'

enum States {
  INITIAL,
  DOWNLOADING,
  FINISHED,
  ERROR
}

export default Vue.extend({
  name: 'DownloadComponent',
  store,
  components: {
    DownloadButton,
    ModalComponent
  },
  data() {
    return {
      state: States.INITIAL,
      States
    }
  },
  mounted() {
    const button = document.getElementById("downloadButton")
    if (!button) {
      return
    }
    button.addEventListener("click", () => {
      (this.$refs.modalComponent as any).openpopup()
    })
  },
  computed: {
    price() {
      return this.$store.getters.price
    },
    colors() {
      return this.$store.getters.getColors
    },
    message() {
      const colors = this.$store.getters.getColors
      const shareLinkBuilderService = new ShareLinkBuilderService(DEFAULT_BASE_URL)
      const link = shareLinkBuilderService.build(colors)
      return link
    }
  },
  methods: {
    async downloadItem() {
      // from https://stackoverflow.com/questions/53772331/vue-html-js-how-to-download-a-file-to-browser-using-the-download-tag
      this.state = States.DOWNLOADING
      try {
        const body = {
          price: this.price,
          colors: this.colors,
          configuratorLink: this.message
        }
        const response = await axios.post(`${process.env.VUE_APP_SERVER}pdf`, body, { responseType: 'blob' })
        const blob = new Blob([response.data], { type: 'application/pdf' })
        const link = document.createElement('a')
        link.href = URL.createObjectURL(blob)
        link.download = this.createFilename()
        link.click()
        URL.revokeObjectURL(link.href)
        this.state = States.FINISHED
      } catch (e) {
        this.state = States.ERROR
        throw e
      }
    },
    createFilename() {
      const datetime = new Date()
      const [year, month, day] = datetime.toISOString().slice(0, 10).split('-')
      return `Kieser_Design_Konfigurator_${day}_${month}_${year}`
    },
    resetModal() {
      this.state = States.INITIAL
    }
  }
})
